import { render, staticRenderFns } from "./PlatformEntityCard.vue?vue&type=template&id=528e78af&scoped=true"
import script from "./PlatformEntityCard.vue?vue&type=script&lang=ts"
export * from "./PlatformEntityCard.vue?vue&type=script&lang=ts"
import style0 from "./PlatformEntityCard.vue?vue&type=style&index=0&id=528e78af&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528e78af",
  null
  
)

export default component.exports